import React, { useState, useEffect } from 'react'
import createMarkup from './common/createMarkup'
import heroStyles from 'styles/hero.module.scss'
import { getCookie } from 'utils/cookie'

const arrClassNames = {
  B: heroStyles.boxedBHeadline,
  C: heroStyles.boxedCHeadline,
  H: heroStyles.boxedCHeadline,
  I: heroStyles.boxedBHeadline,
}

const getClassName = revampViewBucket =>
  ['A', 'D'].includes(revampViewBucket)
    ? heroStyles.headline
    : ['B', 'C', 'H', 'I'].includes(revampViewBucket)
    ? arrClassNames[revampViewBucket]
    : heroStyles.revisedHeadline

function Headline({ content }) {
  const [state, setState] = useState({
    revampViewBucket: '',
  })
  useEffect(() => {
    const revampViewBucket = getCookie('revampView')
    setState({ revampViewBucket })
  }, [])

  return (
    <h1
      className={getClassName(state.revampViewBucket)}
      dangerouslySetInnerHTML={createMarkup(content)}
    />
  )
}

export default Headline
